module.exports = __webpack_public_path__ + "static/media/ELS50PG01.5a3ef4da.png";